import { render, staticRenderFns } from "./ModeChange.vue?vue&type=template&id=21a6123f&"
import script from "./ModeChange.vue?vue&type=script&lang=js&"
export * from "./ModeChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports